<template>
  <h1>PAGE 404</h1>
</template>

<script>
export default {
  name: 'Page404',
}
</script>
